module.exports = __webpack_public_path__ + "atomic/molecule/m-dossier-tile/routes.svg?v=eae713";


//////////////////
// WEBPACK FOOTER
// ./Sig.Web/src/atomic/molecule/m-dossier-tile/routes.svg
// module id = 69
// module chunks = 2